module.exports = __webpack_public_path__ + "static/media/ivory_scam_pop@2x.c6b5418c.jpg";